module.exports = __webpack_public_path__ + "img/popups-from-the-site.20e52601.png";